<template>
    <div style="max-height: 500px;overflow-y: auto">
      <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addFamilyPerson()">添加成员</el-button>
      <el-table
        size="mini"
        :data="tableData"
        border
        style="width: 100%;margin-top: 10px"
        highlight-current-row>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="60"
          align="center">
        </el-table-column>
        <el-table-column
          label="性别"
          width="50"
          align="center">
          <template slot-scope="scope">
            <span>{{getSex(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="出生日期"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话号码"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="timelist"
          label="接听电话时间段"
          min-width="90"
          align="center">
        </el-table-column>

      </el-table>
      <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
      <el-dialog
        width="500px"
        title="添加成员"
        :visible.sync="innerAddPerson"
        append-to-body>
        <el-form style="margin-right: 25px" :model="addFamilyForm" :rules="addFamilyRules" ref="addFamilyForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="成员姓名" prop="name">
            <el-input v-model="addFamilyForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="name">
            <el-input type="number" v-model="addFamilyForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入关系备注"
              v-model="addFamilyForm.remark">
            </el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button @click="closeFamily()">取 消</el-button>
          <el-button type="primary" @click="submitAddEdit('addFamilyForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'familyOldPerson',
  model: {
    prop: 'familyShow',
    event: 'change'
  },
  props: {
    familyData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      frequencys: [],
      projects: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      innerAddPerson: false,
      addFamilyForm: {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        personid: ''
      },
      addFamilyRules: {
        name: [
          { required: true, message: '请输入成员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.tableData = this.familyData.oldPersons
  },
  mounted () {
  },
  methods: {
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getFrequencyName (row) {
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequencyid === this.frequencys[i].id) {
          return this.frequencys[i].frequency
        }
      }
    },
    getProjectName (row) {
      for (let i = 0; i < this.projects.length; i++) {
        if (row.projectid === this.projects[i].id) {
          return this.projects[i].projectname
        }
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    addFamilyPerson () {
      this.innerAddPerson = true
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeFamily () {
      this.addFamilyForm = {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        personid: ''
      }
      this.innerAddPerson = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/familyOldPerson.vue